import React, { type InputHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import NoTrailingSpace from "src/shared/forms/validations/NoTrailingSpace";
import { required as Required } from "src/shared/forms/validations/Required";

const MIN_LIST_NAME_CHARS: number | undefined = 3;
const MAX_LIST_NAME_CHARS: number | undefined = 20;
const ListNameValidation = Length(MIN_LIST_NAME_CHARS, MAX_LIST_NAME_CHARS);

export interface IListNameInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export default (props: IListNameInputProps) => {
  const {
    inputID,
    label = <FormattedMessage id="lists.list_name" />,
    validationDisabled,
    ...rest
  } = props;
  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={
        !validationDisabled
          ? [Required, ListNameValidation, NoTrailingSpace]
          : undefined
      }
      {...rest}
    />
  );
};
